import React from "react"
import strings from "../../../../localization/strings"
import { IUserDocument, IPosition, IPunchDocument, IHierarchyItem, IPunchBundle, IUIUser } from "../../../../models"
import moment from "moment"
import * as api from "../../../../api"
import AccountStore from "../../../../stores/AccountStore"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import { CircularProgress, FlatButton, SelectField, MenuItem } from "material-ui"
import { browserHistory } from "react-router"
import * as utils from "../../../../helpers/utils"
import { grey400, grey500, amber500 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../../../helpers/hierarchyHelper"
import * as userHelper from "../../../../helpers/userHelper"
import * as punchHelper from "../../../../helpers/punchHelper"
import * as punchActions from "../../../../actions/PunchActions"
import AppStateStore from "../../../../stores/AppStateStore"
import ChooseHierarchyJobPhaseChipForPunch from "../../../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import * as positionHelper from "../../../../helpers/positionHelper"
import * as timeHelper from "../../../../helpers/timeHelper"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"

interface IProps {
    user: IUserDocument
    reloadTimecard(): void
}
interface IState {
    time: string | Date
    ipAddress: string
    employeeAccessHierarchyIds: string[]
    employeeAccessIPHierarchyIds: string[]
    selectedHierarchyItemId: string
    selectedJobId: string
    selectedPhaseId: string
    loading: boolean
    positions: IPosition[]
    selectedPositionId: string
    errorSelectedPositionId: string
}
const notFindIPHierarchy = "not find"

export default class SelfServiceWebPunch extends React.Component<IProps, IState> {
    private timer
    private lastWebPunchNoPosition = "NoPosition"
    constructor(props) {
        super(props)
        this.state = {
            time: moment().format(),
            ipAddress: "",
            employeeAccessHierarchyIds: [],
            employeeAccessIPHierarchyIds: [],
            selectedHierarchyItemId: notFindIPHierarchy,
            selectedJobId: null,
            selectedPhaseId: null,
            loading: true,
            positions: [],
            selectedPositionId: null,
            errorSelectedPositionId: ""
        }
    }

    componentDidMount() {
        this.setTime()
        this.getIPAddressAndHierarchy()
    }

    componentWillUnmount() {
        this.timer &&
            clearInterval(this.timer)
    }

    setTime() {
        this.timer = setInterval(() => {
            this.setState({ time: moment().format() })
        }, 1000)
    }

    async getIPAddressAndHierarchy() {
        const ipAddressRes = await api.getClientIP()
        const ipAddress = ipAddressRes.data
        const employeeAccessHierarchyIds = userHelper.getEmployeeAccessHierarchyIds(this.props.user)
        const employeeAccessIPHierarchyIds = employeeAccessHierarchyIds.filter(i => {
            const hierarchyItem = hierarchyHelper.getInheritedHierarchySettingItems(hierarchyHelper.getHierarchyItemById(i)).ApprovedIPAddresses
            const approvedIPAddresses = hierarchyItem ? hierarchyItem.HierarchyItemSettings.ApprovedIPAddresses : AccountStore.getCurrentAccount().HierarchyItemSettings.ApprovedIPAddresses
            return !approvedIPAddresses || !approvedIPAddresses.length || approvedIPAddresses.includes(ipAddress)
        })

        if (employeeAccessIPHierarchyIds.length === 0) {
            this.setState({
                ipAddress,
                employeeAccessHierarchyIds,
                employeeAccessIPHierarchyIds,
                selectedHierarchyItemId: notFindIPHierarchy,
                selectedJobId: null,
                selectedPhaseId: null,
                loading: false,
            })
        }
        else {
            let selectedHierarchyItemId, selectedJobId, selectedPhaseId
            const storedLastWebPunchHierarchyId = utils.getCookie("LastWebPunchHierarchyId") !== "account" ? utils.getCookie("LastWebPunchHierarchyId") : null
            const storedLastWebPunchJobId = utils.getCookie("LastWebPunchJobId") !== "no" ? utils.getCookie("LastWebPunchJobId") : null
            const storedLastWebPunchPhaseId = utils.getCookie("LastWebPunchPhaseId") !== "no" ? utils.getCookie("LastWebPunchPhaseId") : null
            const employeeDefaultPunchHierarchyId = this.props.user.DefaultPunchHierarchyId || null
            if (employeeAccessIPHierarchyIds.includes(storedLastWebPunchHierarchyId)) {
                selectedHierarchyItemId = storedLastWebPunchHierarchyId
                selectedJobId = storedLastWebPunchJobId
                selectedPhaseId = storedLastWebPunchPhaseId
            }
            else if (employeeAccessIPHierarchyIds.includes(employeeDefaultPunchHierarchyId)) {
                selectedHierarchyItemId = employeeDefaultPunchHierarchyId
                selectedJobId = this.props.user.DefaultJobId
                selectedPhaseId = this.props.user.DefaultPhaseId
            }
            else {
                let employeeAccessIPHierarchyDefinitionLowestLevel
                const employeeAccessIPHierarchies = employeeAccessIPHierarchyIds.map(id => AccountStore.getCurrentAccount().HierarchyItems.find(item => item.Id === id))
                employeeAccessIPHierarchies.forEach(hierarchy => {
                    const hierarchyDefinitionLevel = AccountStore.getCurrentAccount().HierarchyDefinitions.find(item => item.Id === hierarchy.HierarchyDefinitionId).Level
                    if (employeeAccessIPHierarchyDefinitionLowestLevel === undefined || hierarchyDefinitionLevel < employeeAccessIPHierarchyDefinitionLowestLevel) {
                        employeeAccessIPHierarchyDefinitionLowestLevel = hierarchyDefinitionLevel
                    }
                })
                const employeeAccessIPHierarchyDefinitionLowestLevelId = AccountStore.getCurrentAccount().HierarchyDefinitions.find(item => item.Level === employeeAccessIPHierarchyDefinitionLowestLevel).Id
                selectedHierarchyItemId = employeeAccessIPHierarchies.filter(hierarchy => hierarchy.HierarchyDefinitionId === employeeAccessIPHierarchyDefinitionLowestLevelId)[0].Id
                selectedJobId = null
                selectedPhaseId = null
            }

            this.setState({
                ipAddress,
                employeeAccessHierarchyIds,
                employeeAccessIPHierarchyIds,
                selectedHierarchyItemId,
                selectedJobId,
                selectedPhaseId
            }, () => this.getPositions())
        }
    }

    async getPositions() {
        const res = await api.getPositions(this.props.user.Id, this.state.selectedHierarchyItemId, null, this.state.selectedJobId, this.state.selectedPhaseId)
        const positions = res.data
        const lastWebPunchPositionId = utils.getCookie("LastWebPunchPositionId")
        this.setState({
            positions,
            selectedPositionId:
                positions.length > 0 ?
                    this.props.user.DefaultPositionId && positions.find(item => item.Id === this.props.user.DefaultPositionId) ?
                        this.props.user.DefaultPositionId :
                        lastWebPunchPositionId ?
                            lastWebPunchPositionId === this.lastWebPunchNoPosition ?
                                null :
                                positions.find(item => item.Id === lastWebPunchPositionId) ?
                                    lastWebPunchPositionId :
                                    null :
                            null :
                    null,
            loading: false
        })
    }

    async handleWebPunch(time) {
        if (!this.checkValidate()) return
        const timezoneId = await timeHelper.getIANATimezoneNameFromHierarchyJobId(this.state.selectedHierarchyItemId, this.state.selectedJobId)
        const dateTime = timeHelper.getTimezoneTranslatedDateTimeFromLocal(
            moment(time).get("year"),
            moment(time).get("month"),
            moment(time).get("date"),
            moment(time).get("minute"),
            moment(time).get("hour"),
            timezoneId)
        browserHistory.push(`/es/timecards`)
        const punch: IPunchDocument = {
            Id: utils.guid(),
            UserId: this.props.user.Id,
            OwnerUserId: AuthenticationStore.getLoggedInUser().Id,
            AccountId: AccountStore.getCurrentAccount().Id,
            DateTime: dateTime,
            Offline: false,
            HierarchyItemId: this.state.selectedHierarchyItemId,
            JobId: this.state.selectedJobId,
            PhaseId: this.state.selectedPhaseId,
            PositionId: this.state.selectedPositionId,
            MetaData: {
                UploadDateTime: moment().format(),
                Latitude: 0,
                Longitude: 0,
                Accuracy: 0,
                BiometricScore: 0
            },
        }

        const punchBundle = {
            Punch: punch
        } as IPunchBundle

        punchActions.addPunch(this.props.user.Id, punchBundle, false,
            () => {
                localStorage.setItem("findd_LastWebPunchHierarchyId", this.state.selectedHierarchyItemId ? this.state.selectedHierarchyItemId : "account")
                localStorage.setItem("findd_LastWebPunchJobId", this.state.selectedJobId ? this.state.selectedJobId : "no")
                localStorage.setItem("findd_LastWebPunchPhaseId", this.state.selectedPhaseId ? this.state.selectedPhaseId : "no")
                localStorage.setItem("findd_LastWebPunchPositionId", this.state.selectedPositionId ? this.state.selectedPositionId : this.lastWebPunchNoPosition)
                this.props.reloadTimecard()
            },
            true,
            this.state.ipAddress
        )
    }

    checkValidate() {
        let isValidate = true
        const selectedPosition = this.state.positions.find(i => i.Id === this.state.selectedPositionId)
        if (!positionHelper.checkPositionDate(selectedPosition, this.state.time, this.props.user.PayrollPayGroupId)) {
            isValidate = false
            this.setState({ errorSelectedPositionId: positionHelper.getPositionDateErrorStr(selectedPosition) })
        }
        else {
            this.setState({ errorSelectedPositionId: "" })
        }
        return isValidate
    }

    getCustomAccessRight(selectedHierarchy: IHierarchyItem): boolean {
        return this.state.employeeAccessHierarchyIds.includes(selectedHierarchy ? selectedHierarchy.Id : null)
    }

    render() {
        return (
            <div style={{ textAlign: "center", position: "relative", height: this.state.positions.length > 0 ? 375 : 350 }}>
                <div style={{ fontSize: 20, fontWeight: 600, marginTop: 40, marginBottom: 25 }}>{strings.Web_Punch}</div>
                <div style={{ fontSize: 20, marginBottom: 40, color: grey500 }}>{moment(this.state.time).format("MM/DD/YYYY")}</div>
                <div style={{ fontSize: 50, fontWeight: 500, marginBottom: 30 }}>{moment(this.state.time).format("h:mm a")}</div>
                {
                    this.state.loading ?
                        <div style={{ marginTop: 50 }}>
                            <CircularProgress />
                        </div> :
                        <div style={{ fontSize: 16, fontWeight: 500 }}>
                            <div style={{ paddingLeft: 5, paddingRight: 5 }}>
                                {this.state.selectedHierarchyItemId !== notFindIPHierarchy ?
                                    <div>
                                        <span>{`IP: ${this.state.ipAddress}`}</span>
                                        <div style={{ marginTop: 15, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <ChooseHierarchyJobPhaseChipForPunch
                                                hideIcon
                                                hierarchyChipLabel={AccountStore.getJobsEnabled() && strings.ChoosePunchHierarchy}
                                                jobChipLabel={checkJobFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Choose_Job}
                                                phaseChipLabel={punchHelper.checkPhaseFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Choose_Phase}
                                                employee={this.props.user as IUIUser}
                                                punchHierarchyItemId={this.state.selectedHierarchyItemId}
                                                jobId={this.state.selectedJobId}
                                                phaseId={this.state.selectedPhaseId}
                                                handleSelectHierarchyJobPhase={(selectedHierarchyItemId, errorHierarchyId, job, phase, intentionalChanged) =>
                                                    intentionalChanged &&
                                                    this.setState({
                                                        loading: true,
                                                        selectedHierarchyItemId,
                                                        selectedJobId: job ? job.Id : null,
                                                        selectedPhaseId: phase ? phase.Id : null,
                                                        positions: [],
                                                        selectedPositionId: null,
                                                        errorSelectedPositionId: ""
                                                    }, () => this.getPositions())
                                                }
                                                isEmployeePermissionPriority
                                                getCustomNoAccessErrorStr={selectedHierarchy => {
                                                    const messageForDisablePunches = punchHelper.getDisablePuncheMessageByDefinition(selectedHierarchy ? selectedHierarchy.Id : null, null, null)
                                                    const accessRight = this.getCustomAccessRight(selectedHierarchy)
                                                    const ipRegisted = this.state.employeeAccessIPHierarchyIds.includes(selectedHierarchy ? selectedHierarchy.Id : null)
                                                    return messageForDisablePunches ?
                                                        messageForDisablePunches :
                                                        accessRight ?
                                                            ipRegisted ?
                                                                null :
                                                                strings.This_hierarchy_is_not_registered_for_your_IP :
                                                            strings.You_cant_access_this_hierarchy_item
                                                }}
                                            />
                                        </div>
                                    </div> :
                                    <span>{strings.formatString(strings.Hierarchy_not_found_for_IP, this.state.ipAddress)}</span>
                                }
                                {this.state.positions.length > 0 &&
                                    <SelectField
                                        floatingLabelText={strings.Position}
                                        style={{ marginTop: -5, textAlign: "left", width: "60%", height: 70 }}
                                        value={this.state.selectedPositionId}
                                        onChange={(event, index, value) => this.setState({ selectedPositionId: value }, () => this.checkValidate())}
                                        errorText={this.state.errorSelectedPositionId}
                                        errorStyle={{ position: "absolute", bottom: -5 }}
                                    >
                                        <MenuItem value={null} primaryText="" />
                                        {this.state.positions.map(position =>
                                            <MenuItem
                                                key={position.Id}
                                                value={position.Id}
                                                primaryText={position.Name}
                                            />
                                        )}
                                    </SelectField>
                                }
                            </div>
                            <div style={{ position: "absolute", bottom: this.state.positions.length > 0 ? 20 : 30, right: 0, left: 0 }}>
                                <FlatButton
                                    label={strings.Web_Punch.toUpperCase()}
                                    backgroundColor={this.state.selectedHierarchyItemId !== notFindIPHierarchy ? amber500 : grey400}
                                    hoverColor={amber500}
                                    labelStyle={{ color: "white" }}
                                    onClick={() =>
                                        AppStateStore.setConfirmDialogContent({
                                            content: strings.formatString(strings.Do_you_want_to_add_this_punch_at_xtime, moment(this.state.time).format("h:mm a")) as string,
                                            confirm: () => this.handleWebPunch(this.state.time)
                                        })
                                    }
                                    disabled={(this.state.selectedHierarchyItemId !== notFindIPHierarchy ? false : true) || this.state.errorSelectedPositionId}
                                />
                            </div>
                        </div>
                }
            </div >
        )
    }
}